export default "__VITE_PUBLIC_ASSET__deebf5c8__"